exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button.btn.btn-primary[data-v-4cf90a9d], button.btn.btn-secondary[data-v-4cf90a9d] {\n  color: #fff;\n}", ""]);

// exports
